// Note: Not yet generated but should be from data.

// Different techs (connects inventions to tech).
export enum Tech {
  Civic = 'Civic',
  Martial = 'Martial',
  Oratory = 'Oratory',
  Religious = 'Religious'
}
